<template>
    <div id="boxGestioneLottoMatricola" class="sa-ft-gestione sa-ft-gestione-hidden">
        <div class="ft-sa-doc-container">
            <div class="ft-sa-table-header" :style="{ '--grid-columns': gridTemplateColumns }">
                <div v-if="visibleColumns.index">
                    <label class="sa-ft-label primary">🔢 #</label>
                </div>
                <div v-if="visibleColumns.articolo">
                    <label class="sa-ft-label">📦 Codice Lotto</label>
                </div>
                <div v-if="visibleColumns.qta" class="text-center">
                    <label class="sa-ft-label">📊 Q.tà</label>
                </div>
                <div v-if="visibleColumns.produzione" class="text-center">
                    <label class="sa-ft-label">🏭 Data Produzione</label>
                </div>
                <div v-if="visibleColumns.scadenza" class="text-center">
                    <label class="sa-ft-label">🔚 Data Scadenza</label>
                </div>
                <div v-if="visibleColumns.note" class="text-center">
                    <label class="sa-ft-label">📋 Nota</label>
                </div>
                <div v-if="visibleColumns.azioni" class="text-right">
                    <label class="sa-ft-label">⚙️ Azioni</label>
                </div>
            </div>
            <div class="ft-sa-rows-viewport" v-if="lottiMatricole.length > 0">
                <div class="ft-sa-row-card" v-for="(riga, i) in lottiMatricole" :key="i">
                    <div class="ft-sa-row-content" :style="{ '--grid-columns': gridTemplateColumns }">
                        <div v-if="visibleColumns.index" class="ft-sa-col-index">
                            {{ i + 1 }}
                        </div>
                        <div v-if="visibleColumns.articolo">
                            <span class="ft-sa-col-code ft-sa-badge-um">
                                <input type="text" v-model="riga.lottoMatricola" class="sa-ft-input-custom">
                            </span>
                        </div>
                        <div v-if="visibleColumns.qta" class="ft-sa-wrapper-col-qty text-center">
                            <div class="ft-sa-col-code ft-sa-badge-um text-center">
                                <input type="number" @input="getDescrizioneGestione" v-model="riga.quantita"
                                    class="sa-ft-input-custom">
                            </div>
                        </div>
                        <div v-if="visibleColumns.produzione" class="ft-sa-wrapper-col-qty text-center">
                            <div class="text-center m-2">
                                <date-picker v-model="riga.dataOraProduzione" class="sa-ft-input-custom"
                                    format="DD-MM-YYYY" value-type="timestamp" type="date"></date-picker>
                            </div>
                        </div>
                        <div v-if="visibleColumns.scadenza" class="ft-sa-wrapper-col-qty text-center">
                            <div class="text-center m-2">
                                <date-picker v-model="riga.dataOraScadenza" class="sa-ft-input-custom"
                                    format="DD-MM-YYYY" value-type="timestamp" type="date"></date-picker>
                            </div>
                        </div>
                        <div v-if="visibleColumns.note" class="text-center">
                            <div class="ft-sa-col-code ft-sa-badge-um">
                                <input type="text" v-model="riga.note" class="sa-ft-input-custom">
                            </div>
                        </div>
                        <div v-if="visibleColumns.azioni" class="ft-sa-action-group">
                            <button class="ft-sa-action-btn ft-sa-btn-del" title="Elimina"
                                @click="onEliminaLottoMatricola({ index: i })">
                                <b-icon icon="trash"></b-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="ft-sa-rows-viewport d-flex align-items-center justify-content-center">
                <NoDataComponent ref="cmpNoDataComponent" :fontSize="20" title="Inserisci primo lotto/matricola"
                    subtitle="" />
            </div>
            <div class="ft-sa-table-footer">
                <button style="text-align: center;" class="ft-sa-add-row-placeholder" @click="onClickAggiungiLotto">
                    <b-icon icon="plus-circle-fill" class="mr-2"></b-icon>
                    Aggiungi nuovo lotto
                </button>

            </div>

        </div>
    </div>
</template>

<script>
// import axios from "axios";
// import toast from "../../../template/layout/utility/sa-toast";
import DatePicker from "vue2-datepicker";
import NoDataComponent from "../../../template/components/utility/NoDataComponent.vue";
export default {
    components: { DatePicker, NoDataComponent },
    data() {
        return {
            lottiMatricole: [],
            rigaDocumento: { quantita: 0 },
            lotto: {
                idArticolo: null,
                codiceArticolo: null,
                lottoMatricola: null,
                dataOraProduzione: null,
                dataOraScadenza: null,
                quantita: 0,
                note: ""
            }
        };
    },
    mounted() { },
    computed: {
        visibleColumns() {
            return {
                index: true,
                articolo: true,
                qta: true,
                scadenza: true,
                produzione: true,
                note: true,
                azioni: true,
            };
        },

        gridTemplateColumns() {
            const cols = [];
            if (this.visibleColumns.index)
                cols.push("40px");
            if (this.visibleColumns.articolo)
                cols.push("minmax(150px, 1.5fr)");
            if (this.visibleColumns.qta)
                cols.push("minmax(100px, 200px)");
            if (this.visibleColumns.scadenza)
                cols.push("170px");
            if (this.visibleColumns.produzione)
                cols.push("170px");
            if (this.visibleColumns.note)
                cols.push("200px");
            if (this.visibleColumns.azioni)
                cols.push("100px");
            return cols.join(" ");
        }
    },

    methods: {
        init(rigaDocumento) {
            console.log("gestione lotti matricole", rigaDocumento);

            this.rigaDocumento = rigaDocumento;
            this.setLottoMatricola();
            if (this.rigaDocumento.lottiScadenze.length > 0) {
                this.setLottiMatricola()
            }
            this.getDescrizioneGestione();

        },
        onClickAggiungiLotto() {
            console.log("Aggiungi lotto");
            let obj = JSON.parse(JSON.stringify(this.lotto));
            console.log(obj);
            this.lottiMatricole.push(obj)
            this.setLottoMatricola();
            this.getDescrizioneGestione();
        },
        onEliminaLottoMatricola(index) {
            this.lottiMatricole.splice(index.index, 1);
            this.getDescrizioneGestione();
        },
        emitLottoMatricole() {

            this.$emit("lottoMatricoleUpdate", this.lottiMatricole);
        },
        initListLottoMatricole() {
            this.lottiMatricole = [];
            this.getDescrizioneGestione();
        },
        getLottiMatricole() {
            return this.lottiMatricole;
        },
        setLottoMatricola() {
            this.lotto = {
                idArticolo: this.rigaDocumento.idArticolo,
                codiceArticolo: this.rigaDocumento.codiceArticolo,
                dataOraProduzione: null,
                lottoMatricola: null,
                dataOraScadenza: null,
                quantita: 1,
                note: ""
            }
        },

        showBox() {
            document.getElementById("boxGestioneLottoMatricola").classList.remove("sa-ft-gestione-hidden");
            document.getElementById("boxGestioneLottoMatricola").classList.add("sa-ft-gestione-visible");
            this.disabeConferma = true;
        },
        hideBox() {
            document.getElementById("boxGestioneLottoMatricola").classList.remove("sa-ft-gestione-visible");
            document.getElementById("boxGestioneLottoMatricola").classList.add("sa-ft-gestione-hidden");
            this.disabeConferma = true;
        },
        setLottiMatricola() {
            this.lottiMatricole = this.rigaDocumento.lottiScadenze;
        },
        getDescrizioneGestione() {
            console.log(this.rigaDocumento);
            console.log(this.lottiMatricole.length);
            let numeroLottiPresenti = 0;
            if (this.lottiMatricole.length > 0) {
                for (let lotto of this.lottiMatricole)

                    numeroLottiPresenti += new Number(lotto.quantita)

            }
            const nTotali = new Number(this.rigaDocumento.quantita);

            const coloreBlu = '#007bff';
            const coloreGiallo = '#ffc107';
            const coloreRosso = "#b91c1c"

            // Se mancano lotti è giallo, se sono uguali o superiori è blu
            let coloreDinamico = (numeroLottiPresenti < nTotali) ? coloreGiallo : coloreBlu;

            if (numeroLottiPresenti > nTotali) {
                coloreDinamico = coloreRosso;
            }

            let returnValue = `
      <span class="sa-ft-circle-wrapper" style="--color-status: ${coloreDinamico}; --color-main: ${coloreBlu};">
        <span class="sa-ft-circle-value-current">${numeroLottiPresenti}</span>
        <span class="sa-ft-circle-separator">/</span>
        <span class="sa-ft-circle-total">${nTotali}</span>
      </span>
    `



            this.$emit("descrizioneGestione", returnValue)
        },
    },
};
</script>

<style scoped>
.sa-ft-gestione {
    background-color: white;
    position: absolute;
    z-index: 100;
    top: 160px;
    height: calc(100% - 160px);
    width: 100%;
    opacity: 0;
    transition: opacity 1s ease-in-out;
    right: 0;
    left: 0;
    padding: 5px;
}

.sa-ft-gestione-hidden {
    opacity: 0;
    visibility: hidden;
    transition: all 1s ease-in-out;
}

.sa-ft-gestione-visible {
    visibility: visible;
    opacity: 1;
    transition: all 1s ease-in-out;
}

.ft-sa-doc-container {
    font-family: 'Inter', -apple-system, sans-serif;
    background: white;
    padding: 26px;
    padding-top: 10px !important;
    color: var(--text-main);
    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 100% !important;
}

/*
|--------------------------------------------------------------------------
| GRID SHARED
|--------------------------------------------------------------------------
*/

.ft-sa-table-header,
.ft-sa-row-content {
    display: grid;
    grid-template-columns: var(--grid-columns);
    align-items: center;
}

/*
|--------------------------------------------------------------------------
| HEADER
|--------------------------------------------------------------------------
*/

.ft-sa-table-header {
    padding: 12px 30px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: var(--primary);
    flex-shrink: 0;
    background: #f8fafc;
    border-bottom: 1px solid var(--border-color);
    border-radius: 12px;
    position: sticky;
    top: 0;
    z-index: 10;
}

.sa-ft-riferimento-doc {
    display: flex;
    justify-content: center;
    padding: 3px;
}

/*
|--------------------------------------------------------------------------
| VIEWPORT
|--------------------------------------------------------------------------
*/

.ft-sa-rows-viewport {
    flex-grow: 1;
    overflow-y: auto;
    padding: 10px 5px;
    margin-bottom: 10px;
}

.ft-sa-rows-viewport::-webkit-scrollbar {
    width: 6px;
}

.ft-sa-rows-viewport::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
}

/*
|--------------------------------------------------------------------------
| ROW
|--------------------------------------------------------------------------
*/

.ft-sa-row-card {
    background: white;
    border-radius: 12px;
    margin-bottom: 12px;
    transition: all 0.25s ease;
    border: 1px solid #edf2f7;
    position: relative;
    overflow: hidden;
    border-left: 4px solid var(--bg-sidebar-item);
}

.ft-sa-row-card:hover {
    transform: translateY(-2px);
    border-color: var(--primary);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.ft-sa-row-content {
    padding: 10px 16px;
}

/*
|--------------------------------------------------------------------------
| CELLS
|--------------------------------------------------------------------------
*/

.ft-sa-col-index {
    font-weight: 700;
    color: var(--text-muted);
    opacity: 0.5;
}

.ft-sa-col-code {
    font-size: 10px;
    color: var(--primary);
    background: rgba(var(--primary-rgb), 0.1);
    padding: 2px 8px;
    border-radius: 6px;
    display: inline-block;
    margin-bottom: 4px;
    font-weight: 600;
}

.ft-sa-col-desc-articolo {
    font-weight: 700;
    font-size: 13px;
    color: #1a202c;
}

.ft-sa-wrapper-col-qty {
    display: flex;
    justify-content: center;
}

.ft-sa-col-qty {
    background: #f1f5f9;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    color: #475569;
    padding: 4px;
    font-weight: 700;
    text-align: center;
    width: 60px;
}

.ft-sa-col-um-desc {
    font-size: 11px;
    font-weight: 600;
    display: block;
}

.ft-sa-col-price {
    font-variant-numeric: tabular-nums;
    font-weight: 500;
    text-align: right;
    color: #64748b;
}

.ft-sa-col-total {
    font-variant-numeric: tabular-nums;
    font-weight: 700;
    text-align: right;
    font-size: 15px;
    color: #0f172a;
}

/*
|--------------------------------------------------------------------------
| LOTTI
|--------------------------------------------------------------------------
*/

.ft-sa-details-bar {
    background: #f8fafc;
    padding: 10px 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    font-size: 11px;
    justify-content: left;
    border-top: 1px dashed #e2e8f0;
    background-color: #64748b07;
}

.ft-sa-lotto-item {
    display: flex;
    gap: 8px;
    align-items: left;
    border: 2px dotted #334155;
    border-radius: 50px;
    padding: 3px 5px;
}

.ft-sa-meta-tag {
    display: flex;
    align-items: center;
    gap: 5px;
    color: #64748b;
}

.ft-sa-meta-tag strong {
    color: #334155;
    text-transform: uppercase;
    font-size: 9px;
}

/*
|--------------------------------------------------------------------------
| ACTIONS
|--------------------------------------------------------------------------
*/

.ft-sa-action-group {
    display: flex;
    gap: 6px;
    justify-content: flex-end;
}

.ft-sa-action-btn {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    background: white;
    cursor: pointer;
    transition: 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ft-sa-btn-info:hover {
    background: #e0f2fe;
    color: #0369a1;
    border-color: #7dd3fc;
}

.ft-sa-btn-edit:hover {
    background: #f0fdf4;
    color: #15803d;
    border-color: #86efac;
}

.ft-sa-btn-del:hover {
    background: #fef2f2;
    color: #b91c1c;
    border-color: #fecaca;
}

/*
|--------------------------------------------------------------------------
| FOOTER
|--------------------------------------------------------------------------
*/

.ft-sa-table-footer {
    padding-top: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
}

.ft-sa-add-row-placeholder {
    border: 2px dashed #cbd5e1;
    border-radius: 12px;
    padding: 12px;
    margin-bottom: 20px;
    text-align: center;
    color: #64748b;
    cursor: pointer;
    transition: all 0.2s;
    background: #f8fafc;
    width: 100%;
    max-width: 400px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ft-sa-add-row-placeholder:hover:not(:disabled) {
    background: white;
    border-color: var(--primary);
    color: var(--primary);
    transform: translateY(-1px);
}

.ft-sa-add-row-placeholder:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/*
|--------------------------------------------------------------------------
| BADGE
|--------------------------------------------------------------------------
*/

.ft-sa-badge-um {
    font-size: 10px;
    background: #f1f5f9;
    color: #475569;
    padding: 2px 6px;
    border-radius: 4px;
    border: 1px solid #e2e8f0;
}

.ft-sa-badge-um-input {
    font-size: 10px;
    background: #f1f5f9;
    color: #475569;
    padding: 2px 6px;
    border-radius: 4px;
    border: 1px solid #0369a1 !important;
}

.sa-ft-input-custom {
    width: 100%;
    border: none;
    background: transparent;
    text-align: center;
    font-weight: 700;
    color: #475569;
}

/*
|--------------------------------------------------------------------------
| HELPERS
|--------------------------------------------------------------------------
*/

.text-center {
    text-align: center;
}

.text-right {
    text-align: right;
}
</style>
